var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-like-button"},[_c('Heart',{class:{ 'has-interacted': _vm.hasInteracted, 'liked': _vm.isLiked, 'not-liked': !_vm.isLiked },nativeOn:{"click":function($event){return _vm.onClickHeart.apply(null, arguments)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }